import { render, staticRenderFns } from "./vessel-nomination-form.vue?vue&type=template&id=6d4af310&scoped=true&"
import script from "./vessel-nomination-form.vue?vue&type=script&lang=js&"
export * from "./vessel-nomination-form.vue?vue&type=script&lang=js&"
import style0 from "./vessel-nomination-form.vue?vue&type=style&index=0&id=6d4af310&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6d4af310",
  null
  
)

export default component.exports